import { Col, Row } from "reactstrap";
import {
    ROLES_OPTIONS,
    STATUS_OPTIONS,
    TIMEZONE
} from "@constants/panel/common";

import AsyncSelectField from "@components/fields/react-select/async-select";
import FixedActionFooterLayout from "@components/views/fixed-action-footer-layout";
import InputField from "@components/fields/input-field";
import Select from "@components/fields/react-select/select";
import UploadImage from "@src/views/common/upload-image";
import useAccount from "./use-account";
import useFilters from "@src/views/common/hooks/use-filter";

const MyAccount = () => {
    const {
        loading,
        isDirty,
        onSubmit,
        handleCancel,
        methods,
        updateLoading,
        image,
        handleImageSelect,
        userDetails,
        uploadLoading
    } = useAccount();

    const { loadAsyncOptions } = useFilters();

    const {
        control,
        formState: { errors }
    } = methods;

    return (
        <FixedActionFooterLayout
            children={
                <Row>
                    <Col lg={4}>
                        <UploadImage
                            image={image}
                            showRemove
                            loading={uploadLoading}
                            avatarProps={{
                                name  : userDetails?.name,
                                status: userDetails?.status
                            }}
                            handleImageSelect={handleImageSelect}/>
                    </Col>
                    <Col lg={8}>
                        <Row>
                            <Col lg={6}>
                                <InputField
                                    errors={errors}
                                    id="name"
                                    label="Name"
                                    name="name"
                                    required
                                    control={control}/>
                            </Col>
                            <Col lg={6}>
                                <InputField
                                    errors={errors}
                                    id="title"
                                    label="Title"
                                    name="title"
                                    required
                                    control={control}/>
                            </Col>
                            <Col lg={4}>
                                <InputField
                                    errors={errors}
                                    id="email"
                                    label="Email"
                                    disabled
                                    name="email"
                                    required
                                    control={control}/>
                            </Col>
                            <Col lg={4}>
                                <InputField
                                    errors={errors}
                                    type="number"
                                    id="phone"
                                    label="Phone Number"
                                    name="phone"
                                    required
                                    control={control}/>
                            </Col>
                            <Col lg={4}>
                                <Select
                                    options={ROLES_OPTIONS}
                                    errors={errors}
                                    label="Role"
                                    name="role"
                                    disabled
                                    id="role"
                                    control={control}
                                    required/>
                            </Col>
                            <Col lg={6}>
                                <Select
                                    options={STATUS_OPTIONS}
                                    errors={errors}
                                    label="Status"
                                    disabled
                                    name="status"
                                    id="status"
                                    control={control}
                                    required/>
                            </Col>
                            <Col lg={6}>
                                <Select
                                    options={TIMEZONE}
                                    errors={errors.region}
                                    label="Timezone"
                                    name="region.timezone"
                                    id="timezone"
                                    control={control}
                                    required/>
                            </Col>

                            <Col lg={12}>
                                <AsyncSelectField
                                    loadOptions={(value, callback) => {
                                        loadAsyncOptions({
                                            value,
                                            callback,
                                            type: "products"
                                        });
                                    }}
                                    defaultOptions
                                    id="platforms"
                                    isMulti
                                    isClearable
                                    label="Products"
                                    name="platforms"
                                    required
                                    control={control}
                                    errors={errors}/>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            }
            subject="settings"
            breadCrumbItem={[
                {
                    title : "My Account",
                    active: true
                }
            ]}
            action="update"
            loading={loading}
            updateLoading={updateLoading}
            isDirty={isDirty}
            submitTestId="save-button"
            cancelTestId="cancel-app-submit"
            onSubmit={onSubmit}
            handleCancel={handleCancel}/>
    );
};
export default MyAccount;
